import * as z from "zod";

const productTypeSchema = z.enum([
  "returns",
  "order-editing",
  "oms",
  "email-sms",
  "conversion",
  "support-ai",
]);

export const deleteOnboardingConfiguration = {
  name: "deleteOnboardingConfiguration" as const,
  input: z
    .object({
      // Either merchantId or publicDomain must be provided
      merchantId: z.string().min(1).optional(),
      publicDomain: z.string().min(1).optional(),
      product: productTypeSchema,
    })
    .refine((data) => data.merchantId || data.publicDomain, {
      message: "Either merchantId or publicDomain must be provided",
    }),
  output: z.object({
    success: z.boolean(),
    merchantId: z.string().nullable(),
    publicDomain: z.string().optional(),
    product: productTypeSchema,
    deleted: z.boolean(),
  }),
};

export const toggleOnboardingConfigurationActive = {
  name: "toggleOnboardingConfigurationActive" as const,
  input: z
    .object({
      // Either merchantId or publicDomain must be provided
      merchantId: z.string().min(1).optional(),
      publicDomain: z.string().min(1).optional(),
      product: productTypeSchema,
    })
    .refine((data) => data.merchantId || data.publicDomain, {
      message: "Either merchantId or publicDomain must be provided",
    }),
  output: z.object({
    success: z.boolean(),
    merchantId: z.string().nullable(),
    publicDomain: z.string().optional(),
    product: productTypeSchema,
    active: z.boolean(),
  }),
};

export type DeleteOnboardingConfigurationInput = z.infer<
  typeof deleteOnboardingConfiguration.input
>;
export type DeleteOnboardingConfigurationOutput = z.infer<
  typeof deleteOnboardingConfiguration.output
>;
export type ToggleOnboardingConfigurationActiveInput = z.infer<
  typeof toggleOnboardingConfigurationActive.input
>;
export type ToggleOnboardingConfigurationActiveOutput = z.infer<
  typeof toggleOnboardingConfigurationActive.output
>;
